<button [attr.aria-label]="'Close' | transloco" type="button" mat-icon-button>
    <vsc-icon>close</vsc-icon>
</button>
